module.exports = __webpack_public_path__ + "static/img/logo.a5dc46c.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 58
// module chunks = 0